<template>
  <div class="booking-sidebar">
    <div class="booking-sidebar__wrapper">
      <div class="booking-sidebar__header" :class="{ 'divider': scrolledList }">
        <div class="booking-sidebar__price">
          <div class="booking-sidebar__price--sum">
            <div class="booking-sidebar__price--sum-default">
              <span>Razem</span>
              <div v-if="promoPrice" class="price">
                <span class="hidden">brak ceny</span>
                <span class="currency">zł</span>
              </div>
            </div>
            <div class="booking-sidebar__price--sum-promo">
              <span>{{ formattedTotalPrice }}</span>
              <div class="currency">
                <Icon icon="couple" />
                <span>zł</span>
              </div>
            </div>
          </div>
          <div class="booking-sidebar__price--deposit">
            <span class="booking-sidebar__price--deposit-price">
              <span>Zaliczka </span><span class="price"><strong>{{ formattedInstallmentPrice }}</strong> zł</span>
            </span>
            <span class="booking-sidebar__price--deposit-description">Pozostała kwota {{ formattedRemainingPrice }} <span class="currency">zł</span> do zapłaty do {{ remainingAmountEndDate }}</span>
          </div>
        </div>
        <div class="booking-sidebar__hotel-name">{{ offer.HotelName }}</div>
      </div>
      <div class="booking-sidebar__list" ref="list">
        <div class="booking-sidebar__details">
          <div class="booking-sidebar__details--people booking-sidebar__details--col">
            <Icon class="icon" icon="couple" />
            <span>Dorośli {{ offer.AdultsCount }} / Dzieci {{ offer.ChildrenCount }}</span>
          </div>
          <div class="booking-sidebar__details--room booking-sidebar__details--col">
            <Icon class="icon" icon="bed" />
            <span>{{ offer.RoomDesc }}</span>
          </div>
          <div class="booking-sidebar__details--food booking-sidebar__details--col">
            <Icon class="icon" icon="kettles" />
            <span>{{ offer.BoardStandardDesc }}</span>
          </div>
          <div class="booking-sidebar__details--airport booking-sidebar__details--col">
            <Icon class="icon-plane" icon="plane" />
            <div class="details">
              <div class="booking-sidebar__details--airport-city">
                <span class="booking-sidebar__details--flight-direction">WYLOT</span>
                <span>{{ offer.DepartureAirportCity }} ({{ offer.DepartureAirportCode }})</span>
                <div class="icon-rotated"><Icon icon="v" /></div>
                <span>{{ offer.ArrivalAirportCity }} ({{ offer.ArrivalAirportCode }})</span>
              </div>
              <div v-if="offer.DepartureFlightTime" class="booking-sidebar__details--airport-travel-time">
                <Icon icon="clock" />
                <span>{{ offer.DepartureFlightTime }}</span>
              </div>
              <div class="booking-sidebar__details--airport-flight-number">
                <span v-if="offer.DepartureAirlineName">Linie: {{ offer.DepartureAirlineName }} /</span>
                <span v-if="offer.DepartureFlightNr">Nr. lotu: {{ offer.DepartureFlightNr }}</span>
              </div>
              <span class="booking-sidebar__details--airport-travel-date">
                <strong>{{ departureDate }}</strong>
                <template v-if="offer.DepartureFlightTime">godz. <strong>{{ offer.DepartureParsedHours }}</strong></template>
              </span>
              <!-- <span class="booking-sidebar__details--airport-luggage">Bagaż do: <strong>20kg</strong>, Bagaż podręczny do: <strong>5kg</strong></span> -->
            </div>
          </div>
          <div class="booking-sidebar__details--airport booking-sidebar__details--col">
            <Icon class="icon-plane-return" icon="plane" />
            <div class="details">
              <div class="booking-sidebar__details--airport-city">
                <span class="booking-sidebar__details--flight-direction">POWRÓT</span>
                <span>{{ offer.ArrivalAirportCity }} ({{ offer.ArrivalAirportCode }})</span>
                <div class="icon-rotated"><Icon icon="v" /></div>
                <span>{{ offer.ReturnDestinationAirportCity }} ({{ offer.ReturnDestinationAirportCode }})</span>
              </div>
              <div v-if="offer.ReturnFlightTime" class="booking-sidebar__details--airport-travel-time">
                <Icon icon="clock" />
                <span>{{ offer.ReturnFlightTime }}</span>
              </div>
              <div class="booking-sidebar__details--airport-flight-number">
                <span v-if="offer.ReturnAirlineName">Linie: {{ offer.ReturnAirlineName }} /</span>
                <span v-if="offer.ReturnFlightNr">Nr. lotu: {{ offer.ReturnFlightNr }}</span>
              </div>
              <span class="booking-sidebar__details--airport-travel-date">
                <strong>{{ returnDate }}</strong>
                <template v-if="offer.ReturnFlightTime">godz. <strong>{{ offer.ReturnParsedHours }}</strong></template>
                </span>
              <!-- <span class="booking-sidebar__details--airport-luggage">Bagaż do: <strong>20kg</strong>, Bagaż podręczny do: <strong>5kg</strong></span> -->
            </div>
          </div>
        </div>

        <div v-if="insurances.length" class="booking-sidebar__additionals">
          <h5>Ubezpieczenia</h5>
          <div v-for="(service, key) in insurances" :key="key" class="item">
            <span>{{ service.Title }} <Icon v-if="service.TooltipHeader || service.TooltipBody" icon="info" /></span>
            <div v-if="service.TooltipHeader || service.TooltipBody" class="tooltip">
              <Icon icon="info" />
              <h4 v-if="service.TooltipHeader">{{ service.TooltipHeader }}</h4>
              <p v-if="service.TooltipBody">{{ service.TooltipBody }}</p>
              <span @click="toggleInsurancesDetailsModal" class="details">Sprawdź szczegóły</span>
            </div>
          </div>
        </div>

        <div v-if="attractions.length" class="booking-sidebar__additionals">
          <h5>Usługi dodatkowe</h5>
          <div v-for="(service, key) in attractions" :key="key" class="item">
            <span>{{ service.Title }}</span>
          </div>
        </div>
      </div>
    </div>

    <DetailsModal v-if="dropdowns.insurancesDetailsModal" class="details-modal"
      @close="toggleInsurancesDetailsModal" title="Szczegóły ubezpieczenia" :footerButton="false" />
  </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapState, mapActions } from 'vuex'

import DetailsModal from '@/components/booking/additionalServices/Details'
import { INSURANCES_CODE, ATTRACTIONS_CODE } from '@/components/booking/types'
import Icon from '@/components/Icon'
import DropdownHandler from '@/components/search/DropdownHandler'
import Store from '@/store/index'
import { SET_OFFER } from '@/store/mutation-types'
import MediaDetector from '@/utils/MediaDetector'
import { addSpace } from '@/utils/priceFormat'

const MUTATION = `Booking/${SET_OFFER}`

@Component({
  store: Store,
  mixins: [
    MediaDetector,
    DropdownHandler,
  ],
  components: {
    Icon,
    DetailsModal,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapState({
      offer: state => state.Booking.offer,
    }),
    formattedRemainingPrice () {
      return addSpace(this.offer.RemainingAmount)
    },
    formattedTotalPrice () {
      return addSpace(this.offer.TotalPrice)
    },
    formattedInstallmentPrice () {
      return addSpace(this.offer.FirstInstallmentValue)
    },
  },
  methods: {
    ...mapActions({
      setOffer: MUTATION,
    }),
  },
})
export default class BookingSidebar extends Vue {
  scrolledList = false
  promoPrice = null

  dropdowns = {
    tooltip: [],
    insurancesDetailsModal: false,
  }

  get remainingAmountEndDate () {
    return moment(this.offer.RemainingAmountEndDate).format('DD.MM.YYYY')
  }

  get departureDate () {
    return moment(this.offer.DepartureDate).format('dd DD.MM.YYYY')
  }

  get returnDate () {
    return moment(this.offer.ReturnDate).format('dd DD.MM.YYYY')
  }

  get insurances () {
    return this.offer.SelectedServices.filter(service => service.ServiceTypeCode == INSURANCES_CODE && service.IsVisible)
  }

  get attractions () {
    return this.offer.SelectedServices.filter(service => service.ServiceTypeCode == ATTRACTIONS_CODE && service.IsVisible)
  }

  // Set to true if max-height is reached
  setScrolledList () {
    if (this.$refs.list.clientHeight == 500) this.scrolledList = true
  }

  created () {
    this.setOffer(this.data)
  }

  mounted () {
    this.dropdowns.tooltip = this.insurances.map(() => false)
    this.setScrolledList()
  }

  toggleInsurancesDetailsModal () {
    this.dropdowns.insurancesDetailsModal = !this.dropdowns.insurancesDetailsModal
  }
}
</script>

<style lang="scss" scoped>
/**
 * Because of layout specification sidebar will be hidden by default.
 * Can be overwritten by another parent component.
 */
.booking-sidebar {
  display: none;

  @include mediaFluid(desktop) {
    display: block;
    position: sticky;
    top: 0;
    z-index: 2;
  }

  &__header {
    position: relative;
    margin-bottom: 12px;

    @include mediaFluid(tablet) {
      margin-bottom: 8px;
    }

    @include mediaFluid(desktop) {
      margin-bottom: 6px;
    }

    &.divider::after {
      content: '';
      position: absolute;
      width: calc(100% + 40px);
      height: 1px;
      bottom: -7px;
      left: -20px;
      background: #ADADAD;
      box-shadow: 0 2px 4px 0px gray;
    }
  }

  &__list {
    max-height: 500px;
    overflow: auto;
  }
}

.booking-sidebar__wrapper {
  padding: 20px;
  max-height: 650px;
  background-color: #fff;
  
  @include mediaFluid(tablet) {
    box-shadow: 0px 0px 3px 0px rgba(0,0,0, .4);
  }

  @include mediaFluid(desktop) {
    position: sticky;
    top: 36px;
  }
}

.booking-sidebar__price {
  @include mediaFluid(tablet) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
  }

  @include mediaFluid(desktop) {
    grid-template-columns: 1fr;
    grid-row-gap: 4px;
  }

  &--sum {
    display: flex;
    align-items: center;

    @include mediaFluid(tablet) {
      align-items: baseline;
    }
  }
  
  &--sum-default {
    display: flex;
    flex-direction: column-reverse;

    @include mediaFluid(desktop) {
      width: 110px;
    }

    > span {
      color: #E71F6C;
      text-transform: uppercase;
      font-size: 1.35em;
      font-weight: bold;
      margin-top: 2px;

      @include mediaFluid(tablet) {
        line-height: normal;
      }
    }

    .price {
      display: flex;
      align-items: end;
      position: relative;
      color: #535353;
      font-weight: bold;
      font-size: 1.15em;
      text-decoration: line-through;
      text-decoration-color: #E71F6C;

      @include mediaFluid(tablet) {
        display: none;
      }

      span {
        line-height: 13px;
      }

      .currency {
        font-size: 11px;
        font-weight: normal;
        line-height: .9em;
      }
    }
  }

  &--sum-promo {
    display: flex;
    flex: 1 0 auto;
    justify-content: right;
    align-items: center;
    color: #E71F6C;
    font-size: 1.2em;

    @include mediaFluid(tablet) {
      justify-content: left;
      margin-left: 22px;
    }

    @include mediaFluid(desktop) {
      margin-left: 0;
    }

    > span {
      font-size: 2.6em;
      font-weight: bold;
      margin-right: 5px;
      line-height: 0.9;

      @include mediaFluid(tablet) {
        line-height: 0.8;
      }

      @include mediaFluid(desktop) {
        margin-right: 12px;
        line-height: 0.85;
      }
    }

    .currency {
      display: flex;
      flex-direction: column;
      text-align: center;

      .figure {
        font-size: 1em;

        @include mediaFluid(tablet) {
          font-size: 1.1em;
        }
      }

      span {
        font-size: .9em;
        
        @include mediaFluid(tablet) {
          font-size: 1em;
        }
      }
    }
  }

  &--deposit {
    margin-top: 8px;
    display: grid;

    @include mediaFluid(tablet) {
      margin-top: 0;
      align-items: end;
    }
  }

  &--deposit-price {
    font-size: .85em;
    font-weight: bold;
    color: #E71F6C;
    text-transform: uppercase;

    @include mediaFluid(tablet) {
      font-size: 1.1em;
      font-weight: normal;
    }

    .price {
      @include mediaFluid(tablet) {
        margin-left: 10px;
      }
      @include mediaFluid(desktop) {
        width: auto;
        margin-left: 0;
      }
    }

    strong {
      @include mediaFluid(tablet) {
        font-size: 1.5em;
      }
    }

    > span {
      @include mediaFluid(desktop) {
        width: 110px;
        display: inline-block;
      }
    }
      
  }

  &--deposit-description {
    font-family: 'Gotham Book';
    font-size: .75em;
    font-weight: lighter;
    color: #545454;
    margin-top: 4px;
  }

  .currency {
    text-transform: uppercase;
  }
}

.booking-sidebar__hotel-name {
  display: none;
  width: 100%;
  text-align: left;
  color: #005CA9;
  font-family: 'Gotham Book';
  font-size: 1.1em;
  font-weight: bold;
  margin: 8px 0;
  text-transform: uppercase;

  @include mediaFluid(tablet) {
    display: inline-block;
    margin: 13px 0 0;
    letter-spacing: -0.3px;
  }

  @include mediaFluid(desktop) {
    margin-top: 19px;
  }
}

.booking-sidebar__details {
  display: grid;
  grid-template-columns: 1fr;
  color: #545454;
  font-family: 'Gotham Book';

  @include mediaFluid(tablet) {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }

  @include mediaFluid(desktop) {
    grid-template-columns: 1fr;
  }

  &--col {
    position: relative;
    display: grid;
    grid-template-columns: 35px 1fr;
    padding: 8px 0 6px;
    border-top: 1px solid #ADADAD;
    line-height: 16px;
    font-size: .85em;
    align-items: center;

    &:last-child {
      border-bottom: 1px solid #ADADAD;
    }

    @include mediaFluid(tablet) {
      padding-bottom: 8px;
      grid-template-columns: 26px 1fr;
    }

    @include mediaFluid(desktop) {
      grid-template-columns: 35px 1fr;
    }
  }

  &--people {
    @include mediaFluid(tablet) {
      grid-column: 1;
    }

    @include mediaFluid(desktop) {
      grid-column: auto;
    }

    .icon {
      margin: 2px 0 0 5px;
    }
  }

  &--room {
    @include mediaFluid(tablet) {
      grid-column: 2;
      grid-row: 1 / 3;
      align-items: start;
    }
    
    @include mediaFluid(desktop) {
      grid-column: auto;
      grid-row: auto;
      line-height: normal;
    }

    .icon {
      margin-left: 5px;
      font-size: 1.2em;

      @include mediaFluid(tablet) {
        margin: 7px 0 0 2px;
      }

      @include mediaFluid(desktop) {
        margin: 0 0 0 2px;
      }
    }

    span:last-child {
      @include mediaFluid(tablet) {
        margin-left: 10px;
      }
    
      @include mediaFluid(desktop) {
        margin-left: 0;
      }
    }
  }

  &--food {
    @include mediaFluid(tablet) {
      grid-column: 1;
    }

    .icon {
      margin: -3px 0 0 7px;
      font-size: 1.6em;
    }
  }

  &--airport {
    align-items: start;
    padding: 12px 0px;
    
    @include mediaFluid(tablet) {
      padding: 7px 0;
      border-bottom: 1px solid #ADADAD;
    }

    @include mediaFluid(desktop) {
      border-bottom: none;
    }

    .icon-plane {
      margin: -4px 0 0 4px;
      font-size: 1.5em;

      @include mediaFluid(tablet) {
        margin-top: -1px;
      }
    }

    .icon-plane-return {
      margin: 9px 1px 0px -6px;
      font-size: 1.5em;
      transform: rotate(90deg);

      @include mediaFluid(tablet) {
        margin: 5px 0px 0px -6px;
      }

      @include mediaFluid(desktop) {
        margin: 11px 0px 0px -7px;
      }
    }
  }

  &--airport-city {
    display: flex;
    align-items: center;
    font-family: 'Gotham';
  }

  &--airport-travel-time {
    display: flex;
    align-items: center;
    color: #005CA9;
    font-weight: bold;
    font-family: 'Gotham';
    font-size: .9em;
    text-transform: lowercase;

    @include mediaFluid(tablet) {
      position: absolute;
      left: 5px;
      top: 42px;
      font-size: 1em;
    }

    @include mediaFluid(desktop) {
      flex-direction: column;
      align-items: start;
      left: 35px;
      top: 28px;
    }

    .figure {
      font-size: 1.2em;
      margin-right: 6px;

      @include mediaFluid(desktop) {
        margin-bottom: 1px;
      }
    }
  }

  &--airport-flight-number,
  &--airport-travel-date,
  &--airport-luggage {
    font-size: .95em;
    line-height: 15px;

    @include mediaFluid(tablet) {
      line-height: 16px;
    }
  }

  &--airport-travel-date {
    @include mediaFluid(tablet) {
      letter-spacing: -0.5px;
      font-size: 1em;
    }
  }

  &--flight-direction {
    text-transform: uppercase;
    margin-right: 5px;

    @include mediaFluid(tablet) {
      position: absolute;
      left: 26px;
      top: 8px;
      font-size: .9em;
    }

    @include mediaFluid(desktop) {
      left: 37px;
    }
  }

  .details {
    display: grid;
    grid-row-gap: 2px;

    @include mediaFluid(tablet) {
      padding-left: 65px;
    }

    @include mediaFluid(desktop) {
      padding-left: 74px;
    }
  }

  .icon-rotated {
    display: inline-block;
    transform: rotate(-90deg);
    height: 7px;
    margin: 0 1px;
  }

  .figure--v {
    font-size: 7px;
    color: #005CA9;
  }
}

.booking-sidebar__additionals {
  padding: 11px 0;
  position: relative;
  border-bottom: 1px solid #ADADAD;

  &:last-child {
    border-bottom: none;
  }
  
  h5 {
    margin: 0;
    color: #005CA9;
    text-transform: uppercase;
    font-size: .8em;
  }
}
.booking-sidebar__additionals .item {
  position: relative;
  display: flex;
  align-items: center;
  font-family: 'Gotham Book';
  font-size: .85em;
  color: #545454;
  padding-top: 6px;

  &:hover .tooltip {
    display: block;
  }

  .tooltip {
    position: absolute;
    display: none;
    width: calc(100% - 4px);
    text-align: center;
    background-color: #fff;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
    padding: 10px 20px 20px;
    bottom: 20px;
    left: 2px;

    .figure {
      font-size: 1.8em;
    }

    &::before {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 50%;
      transform: rotate(45deg) translateX(-50%);
      width: 16px;
      height: 16px;
      background: #fff;
      box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.3);
    }
  }

  h4 {
    text-align: left;
    text-transform: uppercase;
    color: #005CA9;
    font-family: 'Gotham';
    font-weight: normal;
    margin: 10px 0;
  }

  p {
    text-align: left;
    font-size: .9em;
    line-height: 16px;
  }

  .figure {
    color: #005CA9;
    font-size: 1.2em;
  }
  
  .details {
    display: inherit;
    text-align: left;
    color: #005CA9;
    text-transform: uppercase;
    text-decoration: underline;
    font-family: 'Gotham';
    font-weight: normal;
    font-size: .9em;
    margin-top: 12px;
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.details-modal .modal-dialog__wrapper {
  max-width: 1050px;
}
</style>


// WEBPACK FOOTER //
// src/components/booking/Sidebar.vue